import { cn } from "../../../components/ui/utils";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";
import { HeroForceCanvas } from "./HeroForceCanvas";

type HeroNeuralBackdropProps = {
  scrollProgress: number;
};

export function HeroNeuralBackdrop({ scrollProgress }: HeroNeuralBackdropProps) {
  const reducedMotion = usePrefersReducedMotion();

  const py1 = scrollProgress * 72;
  const py2 = scrollProgress * -48;
  const py3 = scrollProgress * 36;
  const scale = 1 + scrollProgress * 0.04;

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden>
      <div className="absolute inset-y-0 left-1/2 z-0 w-[100%] max-w-[100vw] min-w-full -translate-x-1/2">
        <HeroForceCanvas scrollProgress={scrollProgress} enabled={!reducedMotion} />
      </div>

      <div
        className="absolute -right-[10%] top-0 h-[min(520px,55vh)] w-[min(520px,90vw)] rounded-full bg-teal-500/12 blur-[100px] will-change-transform"
        style={{ transform: `translate3d(0, ${py1}px, 0) scale(${scale})` }}
      />
      <div
        className="absolute -left-[8%] bottom-[15%] h-[min(480px,50vh)] w-[min(480px,85vw)] rounded-full bg-cyan-500/10 blur-[90px] will-change-transform"
        style={{ transform: `translate3d(0, ${py2}px, 0) scale(${1 + scrollProgress * 0.02})` }}
      />
      <div
        className="absolute left-[20%] top-[35%] h-[min(320px,40vh)] w-[min(320px,70vw)] -translate-x-1/2 rounded-full bg-teal-600/[0.07] blur-[80px] will-change-transform"
        style={{ transform: `translate3d(-50%, ${py3}px, 0)` }}
      />

      <div
        className={cn(
          "absolute inset-0 opacity-[0.04]",
          !reducedMotion && "landing-hero-grid-drift",
        )}
        style={{
          backgroundImage: `linear-gradient(rgba(79,209,197,0.4) 1px, transparent 1px),
            linear-gradient(90deg, rgba(79,209,197,0.35) 1px, transparent 1px)`,
          backgroundSize: "48px 48px",
          transform: `translate3d(0, ${scrollProgress * 20}px, 0)`,
        }}
      />
    </div>
  );
}
